import { message } from "antd";
import Subjects from "../models/subjects";
import DictionaryTypes from "../models/dictionary-types";
import { HttpUtils } from "./http-utils";

const webApiUrl = "/darshana/api/dictionaries";

class DictionariesService {

  httpUtils: HttpUtils;

  constructor() {
    this.httpUtils = new HttpUtils();
  }

  handleResponse(response: Response) {

    return response.text().then(text => {

      const data = text && JSON.parse(text);

      if (response.status === 401) {
        window.location.replace("/login");
        // return Promise.reject("unauthorized");
      }

      if (!response.ok) {

        const error = (data && data.message) || response.statusText;

        message.error(`Ошибка получения данных: ${error}`);

        return Promise.reject(error);
      }

      return data;
    });
  }

  getDictionary = async (subject: Subjects, type: DictionaryTypes) => {

    var params = {
      subject: subject
    };
    const urlParams = new URLSearchParams(Object.entries(params));
    const request = new Request(`${webApiUrl}/${type}?${urlParams}`, { method: "GET" });
    return await fetch(request).then(this.handleResponse);
  }

  createItem = async (subject: Subjects, name: string, type: DictionaryTypes) => {

    const options = {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name, subject: subject })
    }
    const request = new Request(`${webApiUrl}/${type}`, options);

    return await fetch(request);
  }

  deleteItem = async (id: string, type: DictionaryTypes) => {

    const request = new Request(`${webApiUrl}/${type}/${id}`, { method: "DELETE" });

    return await fetch(request);
  }

  getNumbersWithThemes = async (subject: Subjects, successHandler: ((data: any) => any)) => {

    var params = {
      subject: subject
    };
    const urlParams = new URLSearchParams(Object.entries(params));
    const request = new Request(`${webApiUrl}/numbers-with-themes?${urlParams}`, { method: "GET" });

    const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler);

    return fetch(request).then(handler);
  }
}

export default DictionariesService;